import script from "./xtx-skeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./xtx-skeleton.vue?vue&type=script&setup=true&lang=js"

import "./xtx-skeleton.vue?vue&type=style&index=0&id=526bcbc5&scoped=true&lang=less"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526bcbc5"]])

export default __exports__